// shadcnVars.ts — يحوّل BrandTokens (هويّة Smart Stable) إلى متغيّرات CSS بأسماء shadcn/ui
// الدلاليّة (--background, --primary, --sidebar...) بحيث تتّبع كل مكوّنات shadcn/Tailwind
// المجموعة اللونيّة النشطة تلقائيًّا دون أي كود إضافيّ في كل مكوّن.
import type { BrandTokens } from './brandPalettes';

export function applyShadcnVars(tokens: BrandTokens): void {
	const root = document.documentElement;
	const set = (name: string, value: string) => root.style.setProperty(name, value);

	// إبقاء متغيّرات --smart-* القديمة لأي كود يقرأها مباشرةً.
	for (const [key, value] of Object.entries(tokens)) {
		set(`--smart-${key}`, value);
	}

	set('--background', tokens.page);
	set('--foreground', tokens.text);
	set('--card', tokens.card);
	set('--card-foreground', tokens.text);
	set('--popover', tokens.card);
	set('--popover-foreground', tokens.text);
	set('--primary', tokens.gold);
	set('--primary-foreground', tokens.ink);
	set('--secondary', tokens.cardSoft);
	set('--secondary-foreground', tokens.text);
	set('--muted', tokens.cardSoft);
	set('--muted-foreground', tokens.muted);
	set('--accent', tokens.goldSoft);
	set('--accent-foreground', tokens.text);
	set('--destructive', tokens.rose);
	set('--destructive-foreground', '#ffffff');
	set('--border', tokens.line);
	set('--input', tokens.line);
	set('--ring', tokens.gold);
	set('--radius', '0.625rem');

	set('--chart-1', tokens.gold);
	set('--chart-2', tokens.blue);
	set('--chart-3', tokens.green);
	set('--chart-4', tokens.rose);
	set('--chart-5', tokens.warning);

	set('--sidebar', tokens.sidebarAccent);
	set('--sidebar-foreground', tokens.surface);
	set('--sidebar-primary', tokens.gold);
	set('--sidebar-primary-foreground', tokens.ink);
	set('--sidebar-accent', 'rgba(255,255,255,0.1)');
	set('--sidebar-accent-foreground', tokens.surface);
	set('--sidebar-border', 'rgba(255,255,255,0.12)');
	set('--sidebar-ring', tokens.gold);

	// بوابة الملّاك (بطلب المستخدم 2026-07-12: توحيد الألوان مع «الهويّة اللونيّة» المختارة من
	// System Settings بدل عائلة بُنّيّة منفصلة) — --owner-sidebar/--owner-accent يُصرَّحان في
	// styles/index.css كأسماء بديلة صريحة لنفس --sidebar/--primary الإداريّين (لا قيمة JS هنا)،
	// فيتغيّران تلقائيًّا مع أيّ تبديل «باترن» من لوحة التحكّم. تدرّج الباند الترحيبيّ وظلّ
	// البطاقات مُشتقَّان حسابيًّا من --owner-sidebar نفسه عبر color-mix() في نفس الملفّ.
}
